import { ListPagination, ResponseError } from '~/utils';
import request from '../request';

export const getCustomers = async ({
  page = ListPagination.INITIAL_PAGE,
  size = 25,
}: GetCustomersProps): Promise<ListResponse<Customer>> => {
  try {
    const { data } = await request.get('/customers', {
      params: {
        page_size: size,
        page,
      },
    });
    return data;
  } catch (error) {
    throw new ResponseError(error);
  }
};

export const getCustomerById = async (
  customerId: string,
): Promise<Customer> => {
  try {
    const { data } = await request.get(`/customers/${customerId}`);
    return data;
  } catch (error) {
    throw new ResponseError(error);
  }
};

export const getCustomerAccounts = async (
  customerId: string,
): Promise<CustomerAccount[]> => {
  try {
    const { data } = await request.get(`/customers/${customerId}/accounts`);
    return data;
  } catch (error) {
    throw new ResponseError(error);
  }
};
